import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_SearchCourse = _resolveComponent("SearchCourse")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, {
    class: _normalizeClass(["jfschool", _ctx.theme])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, { style: { position: 'fixed', zIndex: 1, width: '100%', top: 0 } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu, {
            theme: "light",
            mode: "horizontal",
            selectedKeys: _ctx.selectedKeys,
            "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedKeys) = $event)),
            style: { lineHeight: '36px' }
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menulist, (item) => {
                return (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: item.name,
                  onClick: ($event: any) => (_ctx.navclick(item))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.meta.title), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["selectedKeys"]),
          _createVNode(_component_SearchCourse, {
            class: "search",
            theme: _ctx.theme
          }, null, 8, ["theme"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_content, { style: { marginTop: '36px' } }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_router_view, {
            key: _ctx.$route.path,
            style: {"height":"100%"},
            class: "router-view"
          }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}